@font-face {
    font-family: 'OpenSans';
    src:
        url('../assets/OpenSans-VariableFont_wdth,wght.ttf');
}

.agendaCase{
    border-width: 2px;
    border-radius: 5px;
    border-color:#e1ebff;
    padding-left: 2px;
    cursor: pointer;

}

.agendaCase:active{
    opacity: 0.5;
}

.red{
    background-color:#f96c6c;
    color: black;
}

.green {
    background-color:#6afb93;
    color: black;
}

.blue {
    background-color: #82c3fc;
    color: black;
}

.purple {
    background-color: #e2b4fd;
    color: black;
}

.yellow {
    background-color: #F7FC47;
    color: black;
}

.darkGreen {
    background-color: #1A963D;
    color: black;
}

.pink {
    background-color: #FA1E92;
    color: black;
}

.darkNavyBlue {
    background-color: #2d187a;
    color: white;
}

.white {
    background-color: white;
    color: black;
}

.white:active {
    background-color: #e1ebff;
}

.dark {
    background-color: #5c5c5c;
    color: white;
    font-weight: bold;
}
.brownYellow {
    background-color: #f1f1d9;
    color: black;
}

.accentEdit{
    border-color: red;
    border-width: 3px;
}

.caseExtLayout{
    display: flex;
    justify-content: space-between;
    margin-left: 5px;
}

.canceled{
    text-decoration: line-through;
    text-decoration-thickness: 2px;
}

.header{
    font-weight: 650;
    font-family: OpenSans, sans-serif;
    font-size: 104%;
}

.horizontalPaddingOne{
    padding-left: 1px;
    padding-right: 1px;
}

.iconStyle{
    width: 1.5em;
    height: 1.5em;
    cursor: pointer;
}